import { useStore } from '@/store/store';
import { useGlobalContext } from '@/store/contexts/global-context';

export const useShouldShowNotification = (hasNewContent: boolean): boolean => {
    const { isLoggedIn, isAndroidWrapper, isXsellWrapper } = useGlobalContext();
    const showNewGames = useStore((storeState) => storeState.uiToggles.showNewGames);

    return isLoggedIn && showNewGames && hasNewContent && (isAndroidWrapper || isXsellWrapper);
};
